module.exports = __webpack_public_path__ + "img/iphone-dark.12cfe785.png";